import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaArrowCircleRight } from "react-icons/fa";

export default function CustomersHighlight(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const partnersList = [
    { name: "Tier 3 Data Centre set up as a Turnkey Solutions", country: "Kenya Airport Authority", initials: "KAA" },
    { name: "Tier 2 Data Centre Setup as a Turnkey Solution", country: "Kenya Electricity Transmission Co.td", initials: "KET" },
    { name: "Data Voice and Fiber Back Bone Installation.  ", country: "Numeral Machine Complex ", initials: "NMC" },
    { name: "Data Center Setup and Services, LAN Cat 6 Installation and Maintenance Power Setup.", country: "Citi Bank Kenya", initials: "CBK" },
    { name: "Data Centre Setup - LAN Inracking. Copper, PanMPO - OM4 Fiber Links and Network Activation.", country: "National Microfinance Bank Tanzania ", initials: "NMB" },
    { name: "Tier 3 Data Center Setup as a Turnkey Solution", country: "Kenya Women Finance Trust", initials: "KWFT" },
    { name: "Raw Power and UPS Power Solution.", country: "Juhudi Kilimo", initials: "JK" },
    { name: "Fiber CAT6/Wireless Internet Hotspots Installation, Maintenance and Support, Setup and Maintenance Power Installation.", country: "Hilton Hotel - Kenya ", initials: "HH-K" },
    { name: "Fiber CAT6/Wireless Internet Hotspots Installation, Maintenance and Support. Cat6, Cat5, Fiber Backbone Installation for Data and Voice.", country: "Continental Resort Mombasa", initials: "CR" },
    { name: "Fiber CAT6/Wireless Internet Hotspots Installation, Maintenace and Support.", country: "Safari Park Hotel Nairobi", initials: "SP" },
    { name: "Cat6, Cat5, Fiber Backbone Installation and Wireless Internet Hotspots Installation Maintenace and Support. ", country: " (Lillian Towers) Nairobi", initials: "SCH" },
    { name: "Setup and Maintenace of Power Installation, Data and Voice Installation on CAT6 and Wireless Installation.", country: "Shamz Hotel, Isiolo ", initials: "SH" },
    { name: "ETS Alarms, PLC Configurations, Power Configurations and BTS setup, Air Conditioning Control Units.", country: "Engineering Networks Solutions Ltd ", initials: "ENSL" },
    { name: "Fiber & Cat5e, Wireless Internet Hotspots Installation, Maintenace and Support.", country: "DoCoMo Inter Touch UAE", initials: "DIT" },
    { name: "Electric Fencing, Gen Sets Installation, Feeder Cables Installation, Air Con Control Units Design and Installation and AWL Installation. ", country: "Reticulation Masters Ltd. ", initials: "RML" },
    { name: "Data Center setup, Voice and CAT 6 PABX setup. ", country: "Beta Health Care ", initials: "BHC" },
    { name: "Fiber, CAT6/Data Center Service, Setup and Maintenace Power Installation.", country: "GlaxoSmithKiine Kenya", initials: "GSK" },
    { name: "Cat6, PABX Setup, Earthing, Networks Maintenace and Service.", country: " MIC Global Risks Kenya and Tanzania.  ", initials: "MIC" },
    { name: "CAT6, PABX Setup, Earthing Networks Maintenace and Service. ", country: " Occidental Insurance", initials: "OI" },
    { name: "Fiber Optics Structured Cabling. ", country: "  African Advance Level Telecom Institute", initials: "AALTI" },

    
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">{getInlineLoader()}</div>
    );
  }

  return (
    <div
      className="MainBodySection bg-surface"
      style={{ paddingTop: "50px" }}
    >
      <div className="container">
        <div className="row pb-5">
          <div className="col-md-12 mb-3">
						<h6
							className="main-section-title mb-5"
						>
							Our Customers
						</h6>
          </div>

          <div className="col-md-12">
            <div className="partners-slider-wrapper position-relative overflow-hidden">
              <div className="partners-slider d-flex align-items-center">
                {[...partnersList, ...partnersList].map((partner, i) => (
                  <div
                    key={i}
                    className="partner-card text-center mx-3 flex-shrink-0"
                    style={{ 
											width: "240px",
										}}
                  >
                    <div
                      className="partner-logo d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2"
                      style={{
                        width: "80px",
                        height: "80px",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: "18px",
                        background: `linear-gradient(135deg, hsl(${(i * 40) % 360}, 70%, 50%), hsl(${(i * 40 + 60) % 360}, 70%, 60%))`,
                      }}
                    >
                      {partner.initials}
                    </div>
                    <div className="fw-medium font-bold">
											<h6
												style={{
													whiteSpace: "normal",
													wordBreak: "break-word",
													lineHeight: "1.3",
												}}
											>
												{partner.name}
											</h6>
										</div>
                    <div className="text-muted small">{partner.country}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        @keyframes slideLeft {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }

        .partners-slider {
          animation: slideLeft 60s linear infinite;
          width: max-content;
        }

        .partners-slider-wrapper {
          white-space: nowrap;
        }

        @media (max-width: 768px) {
          .partners-slider { animation-duration: 70s; }
        }

        @media (prefers-reduced-motion: reduce) {
          .partners-slider { animation: none; }
        }
      `}</style>
    </div>
  );
}
